import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as componentTypes from "../../../../constants/componentTypes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as translationHelper from "../../../../helpers/translationHelper";

import imgClose from "../../../../resources/img/svgicons/close-black.svg";
import imgPdf from "../../../../resources/img/svgicons/pdf.svg";
import imgMaximizable from "../../../../resources/img/svgicons/maximizable.svg";
import imgMaximize from "../../../../resources/img/svgicons/maximize.svg";

class ProductFilesModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeFile: null,
            maximized:
                props.params !== undefined && props.params.maximized !== undefined ? props.params.maximized : false
        };
    }

    getFileById = (fileId) => {
        for (let productFile of this.props.productFileList) {
            if (productFile.id === fileId) {
                return productFile;
            }
        }

        return null;
    };

    componentDidMount() {
        let file = this.getFileById(this.props.params.fileId);

        if (file !== null) {
            this.setState({
                activeFile: file
            });
        }
    }

    isVisited = (fileId) => {
        if (
            this.props.params === undefined ||
            this.props.params.visited === undefined ||
            this.props.params.visited === null ||
            typeof this.props.params.visited !== "object"
        ) {
            return false;
        }

        return this.props.params.visited[fileId] !== undefined;
    };

    buildVisited = (fileId, online) => {
        if (
            this.props.params === undefined ||
            this.props.params.visited === undefined ||
            this.props.params.visited === null ||
            typeof this.props.params.visited !== "object"
        ) {
            let visited = {};
            visited[fileId] = {
                online: online,
                page: 1
            };

            return visited;
        }

        let visited = {...this.props.params.visited};
        visited[fileId] = {online: online, page: 1};

        return visited;
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleMaximizeClick = () => {
        this.setState({
            maximized: !this.state.maximized
        });
    };

    handleLocalProductFileClick = (event) => {
        let productFile = this.getFileById(Number(event.currentTarget.dataset.id));

        if (productFile !== null) {
            this.props.dispatchOpenPdfPreviewModalAction(this.props.tabId, {
                fileId: productFile.id,
                online: false,
                maximized: this.state.maximized,
                visited: this.buildVisited(productFile.id, false)
            });
            this.props.dispatchCloseModalAction();
        }
    };

    handleOnlineProductFileClick = (event) => {
        let productFile = this.getFileById(Number(event.currentTarget.dataset.id));

        if (productFile !== null) {
            this.props.dispatchOpenPdfPreviewModalAction(this.props.tabId, {
                fileId: productFile.id,
                online: true,
                maximized: this.state.maximized,
                visited: this.buildVisited(productFile.id, true)
            });
            this.props.dispatchCloseModalAction();
        }
    };

    handleProductFileClick = (event) => {
        if (this.isVisited(Number(event.target.dataset.id))) {
            let productFile = this.getFileById(Number(event.currentTarget.dataset.id));

            if (productFile !== null) {
                this.props.dispatchOpenPdfPreviewModalAction(this.props.tabId, {
                    fileId: productFile.id,
                    online: this.props.params.visited[productFile.id].online,
                    maximized: this.state.maximized,
                    visited: this.props.params.visited
                });
                this.props.dispatchCloseModalAction();
            }
        } else {
            let productFile = this.getFileById(Number(event.target.dataset.id));

            if (productFile !== null) {
                this.setState({
                    activeFile: productFile
                });
            }
        }
    };

    getFileButtons = () => {
        let files = [];

        for (let file of this.props.productFileList) {
            if (this.state.activeFile === null || this.state.activeFile.id !== file.id) {
                files.push(
                    <button
                        key={file.id}
                        className="btn btn-info action-button"
                        data-id={file.id}
                        onClick={this.handleProductFileClick}
                    >
                        {translationHelper.getFileTypeTranslations(file.fileType)}
                    </button>
                );
            } else {
                files.push(
                    <button key={file.id} className="btn btn-info action-button active">
                        {translationHelper.getFileTypeTranslations(file.fileType)}
                    </button>
                );
            }
        }

        return files;
    };

    getMaximizeButton = () => {
        if (this.state.maximized) {
            return (
                <ReactSVG className="maximize" src={imgMaximize} alt="Maximize" onClick={this.handleMaximizeClick} />
            );
        }

        return (
            <ReactSVG
                className="maximizable"
                src={imgMaximizable}
                alt="Maximizable"
                onClick={this.handleMaximizeClick}
            />
        );
    };

    getProductFiles = () => {
        let fileList = [];

        for (let productFile of this.props.productFileList) {
            if (this.state.activeFile === null || this.state.activeFile.id === productFile.id) {
                if (productFile.isOnline()) {
                    fileList.push(
                        <div className="file-row" key={productFile.id}>
                            <div className="col-xs-12 color-primary">
                                {translationHelper.getFileTypeTranslations(productFile.fileType)}
                            </div>
                            <div className="col-xs-12">
                                <ReactSVG className="pdf-icon" src={imgPdf} alt="pdf" />
                                {productFile.name}
                            </div>
                            <div className="col-xs-12">
                                <button
                                    className="btn-info"
                                    data-id={productFile.id}
                                    onClick={this.handleLocalProductFileClick}
                                >
                                    <Translate value="mainTab.openLocalFile" />
                                </button>
                                <button
                                    className="btn-info"
                                    data-id={productFile.id}
                                    onClick={this.handleOnlineProductFileClick}
                                >
                                    <Translate value="mainTab.openOnlineFile" />
                                </button>
                            </div>
                        </div>
                    );
                } else {
                    fileList.push(
                        <div className="file-row online-product" key={productFile.id}>
                            <div className="col-xs-12 color-primary">
                                {translationHelper.getFileTypeTranslations(productFile.fileType)}
                            </div>
                            <div className="col-xs-12">
                                <button
                                    className="btn-info"
                                    data-id={productFile.id}
                                    onClick={this.handleLocalProductFileClick}
                                >
                                    <ReactSVG className="pdf-icon" src={imgPdf} alt="pdf" />
                                    {productFile.name}
                                </button>
                            </div>
                        </div>
                    );
                }
            }
        }

        return fileList;
    };

    render() {
        return (
            <div className={"default-modal files-viewer-modal" + (this.state.maximized ? " maximized" : "")}>
                <header className="color-primary">
                    <ReactSVG className="pdf-icon" src={imgPdf} alt="pdf" />
                    <Translate value="mainTab.productFilesViewer" />
                    {this.getMaximizeButton()}
                    <ReactSVG className="img-close" src={imgClose} alt="close" onClick={this.handleCloseModalClick} />
                </header>
                <div className="modal-content">
                    <div className="header">
                        {this.getFileButtons()}
                        <span className="file-name">
                            {this.state.activeFile === null ? "" : this.state.activeFile.name}
                        </span>
                    </div>
                    <div className="file-open-content">{this.getProductFiles()}</div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    return {
        productFileList: store.formula[ownProps.tabId].productFileList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.PRODUCT_FILES_MODAL));
        },
        dispatchOpenPdfPreviewModalAction: (tabId, params) => {
            dispatch(navigationActions.openModalWithParams(tabId, componentTypes.PRODUCT_FILE_PREVIEW_MODAL, params));
        }
    };
};

export default ProductFilesModal = connect(mapStoreToProps, mapDispatchToProps)(ProductFilesModal);
